import React from 'react';

interface Props {
    headerText: string;    
}
export function PageHeader(props: Props){
    return (
        <>
            <h1>{props.headerText}</h1>
        </>
    );
}